<template>
  <div class="inner-graph-content">
    <Spinner :isLoading="isLoading" />
    <div class="inner-content">
      <div class="inner-graph-content">
        <div class="filter-change-rate">
          <table class="table">
            <tbody>
              <tr>
                <td class="title-field">{{ $t('medicine_name') }}</td>
                <td class="input-field">
                  <el-select v-model="valueMedicineSelected" :no-data-text="$t('no_data')" :placeholder="$t('medicine_name')">
                    <el-option
                      v-for="medicine in medicineOptions"
                      :key="medicine.id"
                      :label="medicine.medicine_name"
                      :value="medicine.medicine_name">
                    </el-option>
                  </el-select>
                </td>
                <td class="title-field">{{ $t('evaluation_unit') }}</td>
                <td class="input-field" style="padding-left: 2%">{{ $t('one_month_30_days') }}</td>
              </tr>
              <tr>
                <td class="title-field">{{ $t('dosing_period') }}</td>
                <td class="input-field">
                  <el-select v-model="valueTimeSelected"  :disabled="valueMedicineSelected ? false : true" :placeholder="$t('dosing_period')">
                    <el-option
                      v-for="(medicine, index) in medicineTimeOptions"
                      :key="index"
                      :label="medicine.medicineEndDate === currentDate ?
                        `${medicine.medicineStartDate} ~ ${medicine.medicineEndDate} ${$t('ongoing_medication')}` :
                        `${medicine.medicineStartDate} ~ ${medicine.medicineEndDate}`" 
                      :value="`${medicine.medicineStartDate} ~ ${medicine.medicineEndDate}`">
                    </el-option>
                  </el-select>
                </td>
                <td class="title-field">{{ $t('total_evaluation_period') }}</td>
                <td class="input-field" style="padding-left: 2%">{{ $t('one_year_360_days') }}</td>
              </tr>
            </tbody>
          </table>
          <div class="btn-container">
            <el-button class="btn-base pos-center show-graph"
              :disabled="valueMedicineSelected && valueTimeSelected ? false : true"
              @click="getSeizureChangeRateData()"><p>{{ $t('show_graph') }}</p></el-button>
          </div>
        </div>
        <div v-if="isShowGraph" style="background: #fff">
          <div id="chart-line" class="chart seizures-graph-area">
            <table class="seizures-set-table">
              <tr>
                <th>{{ $t('the_selected_drug') }}</th>
                <td>{{ valueMedicineSelected }}</td>
              </tr>
              <tr>
                <th>{{ $t('dosing_start_date') }}</th>
                <td v-for="(item, index) in seizureChangeRate.list_medicine_before" :key="index">
                  {{ getLastViewed(item.start_medicine_date) }}
                </td>
              </tr>
            </table>
            <table class="seizures-set-table">
              <tr>
                <th>{{ $t('observation_period') }}</th>
                <td v-for="(item, index) in seizureChangeRate.list_medicine_before" :key="index">
                  {{ getLastViewed(item.from_last_thirty_date) }} 〜 {{ getLastViewed(item.to_date) }} {{ $t('brackets_1_month_30_days') }}
                </td>
              </tr>
              <tr>
                <th>{{ $t('dosing_during_the_observation_period') }}</th>
                <td v-if="medicineBefores.length">
                  {{ medicineBefores.join(`${this.$t('comma')} `) }}
                </td>
                <td v-else>
                  {{ $t('no_applicable_medicine') }}
                </td>
              </tr>
            </table>

            <table class="seizures-set-table">
              <tr>
                <th>{{ $t('evaluation_period') }}</th>
                <td v-for="(item, index) in seizureChangeRate.list_medicine_before" :key="index">
                  {{ getLastViewed(item.start_medicine_date) }} 〜 {{ getLastViewed(item.end_medicine_date) }} {{ $t('brackets_1_year_360_days') }}
                </td>
              </tr>
              <tr>
                <th>{{ $t('dosing_during_the_evaluation_period') }}</th>
                <td v-if="medicines">
                  {{ medicines.join(`${this.$t('comma')} `) }}
                </td>
                <td v-else>
                  {{ $t('no_applicable_medicine') }}
                </td>
              </tr>
            </table>
            <p class="graph-medicine-txt graph-title mb-2 pt-0" style="line-height: 30px;" >{{ $t('seizure_change_rate_graph') }}</p>
            <div class="type-seizures seizures-list-area">
              <el-checkbox-group v-model="checkedTypeSeizure" class="seizure-checkbox-group" v-if="seizureShortCat.length">
                <el-checkbox v-for="typeSeizure in seizureShortCat" :label="typeSeizure.name" :key="typeSeizure.name" :data-shortcat-index="typeSeizure.shortcatIndex">{{typeSeizure.name}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div style="margin-top: -20px">
              <VueApexCharts ref="chartLine" type="line" height="350" :options="chartLineOptions" :series="lineChart" @mounted="mountedLineChart" @updated="updateSeriesLine" ></VueApexCharts>
            </div>
          </div>
          <div class="graph-medicine-txt graph-title" style="line-height: 30px; margin-left: 30px;" >
            <a href="javascript:;" @click="$bvModal.show('modal-medicine-shortcut')" class="modal-syncer" data-target="modal-medicine-shortcut">
              <span class="medicine-text graph-title">{{ $t('dosing_bar') }}</span>
              <span class="medicine-bar-btn">?</span>
            </a>
          </div>
          <div id="chart-time-line" class="chart">
            <div style="margin-right: 20px">
              <VueApexCharts ref="chartTimeLine" type="rangeBar" :height="barHeight * numberItemMedicine" :options="chartOptions" :series="timeLineMedicine"></VueApexCharts>
            </div>
          </div>
        
          <p class="graph-medicine-txt graph-title ml-1-2" style="line-height: 30px;" >{{ $t('seizures_count_table') }}</p>
          <div class="graph-period-table seizure-change-rate-table" style="padding: 20px; overflow: auto" v-if="seizureChangeRate.seizure_data.length">
            <table>
              <tr>
                <th class="type-seizure-name">{{ $t('seizure_type') }}</th>
                <th class="st-obs">{{ $t('observation_period') }}</th>
                <th :class="item === null ? 'st-unable' : null " v-for="(item, index) in seizureChangeRate.seizure_data[0].data" :key="index">{{ $t('evaluation_period') }}{{ index + 1 }}</th>
              </tr>
              <tr v-for="(item, index) in orderByShortcat" :key="index">
                <td class="align-left">{{ item.shortcat_name === 'Other' ? $t('other_seizures') :  !item.shortcat_name ? shortcatLabel[item.shortcat_index] : item.shortcat_name }}</td>
                <td align="center">{{ item.count_last_month }}</td>
                <td :class="value === null ? 'st-unable' : null " v-for="(value, index) in item.data" :key="index">
                  {{ value !== null ? value : "－" }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <b-modal centered id="seizure-observation" class="modal-content center" :hide-header="true" :hide-footer="true" style="width:60%; top: 50%">
      <div class="modal-inner">
        <p class="modal-txt-error mb50" style="line-height: 25px" v-html="$t('since_the_number_of_seizures_during_the_observation_period_is_0')"></p>
        <div class="modal-btn-area clearfix">
          <div class="btn-base pos-center"><a href="javascript:;" class="modal-close" @click="$bvModal.hide('seizure-observation')"><p>{{ $t('ok') }}</p></a></div>
        </div>
      </div>
    </b-modal>

    <b-modal centered id="modal-medicine-shortcut" class="center modal-med-content" 
      :hide-header="true" :hide-footer="true">
        <div class="modal-med-inner">
          <p class="modal-med-ttl">{{ $t('medicine_list') }}</p>
          <div class="modal-medicine-list">
            <table>
              <tr>
                <th>{{ $t('no') }}</th>
                <th>{{ $t('medicine_name') }}</th>
                <th>{{ $t('color') }}</th>
                <th>{{ $t('short_name') }}</th>
              </tr>
              <tr v-for="(medicine, index) in medicineColorShortcuts" :key="index">
                <td>{{index + 1}}</td>
                <td class="medicine-name">{{medicine.medicine_name}}</td>
                <td><p class="med-color" :style="{ 'background-color': medicine.dr_site_color }"></p></td>
                <td>{{medicine.medicine_shortcut_name || "ー"}}</td>
              </tr>
            </table>
          </div>
          <div class="btn-base pos-center"><a href="javascript:;" class="modal-close"  @click="$bvModal.hide('modal-medicine-shortcut')"><p>{{ $t('ok') }}</p></a></div>
        </div>
    </b-modal>
  </div>
</template>

<script>
  import Spinner from '@/js/components/Spinner'
  import moment from 'moment'
  import { BButton, BModal, VBModal } from 'bootstrap-vue'
  import { mapState, mapGetters } from 'vuex'
  import VueApexCharts from 'vue-apexcharts'
  import { Button, Option, Checkbox } from 'element-ui'
  import { seizureColor, defaultDatasets, otherPattern } from '@/js/commons/chartConfig'
  import i18n from'@/lang/i18n'

  export default {
    directives: { BButton, BModal, VBModal },
    components: {
      BButton,
      Spinner,
      VueApexCharts,
      Option,
      Checkbox,
      BModal,
      VBModal
    },
    data () {
      return {
        isLoading: false,
        valueMedicineSelected: '',
        valueTimeSelected: '',
        seizureData: [],
        seizureShortCat: [],
        timeLineMedicine: [],
        checkedTypeSeizure: [],
        statusUpdateLine: false,
        isShowGraph: false,
        barHeight: 70,
        numberItemMedicine: 0,
        currentDate: moment().format('YYYY-MM-DD'),
        medicineName: null,
        shortcatLabel: ['A', 'B', 'C', 'D', 'E', 'F'],
        chartLineOptions: {
          colors: ['#ff0000', '#97C66B', '#FFC727', '#61CFE9', '#FA8D8D', '#AC85D4', '#FF89C0', '#E0E0E0'],
          chart: {
            height: '600px',
            type: 'line',
            zoom: {
              enabled: false
            },
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: true,
            offsetY: -5,
            offsetX: 6,
            formatter: function (val) {
              let label = val === 0 || !val ? '' : val
              return label
            },
            style: {
              fontSize: '12px',
              fontWeight: 'normal',
            },
            background: {
              enabled: false,
              foreColor: '#fff',
              padding: 5,
            },
          },
          stroke: {
            curve: 'straight',
            lineCap: 'butt',
            width: 2,
          },
          markers: {
            size: 4,
            shape: "circle",
            radius: 4,
            hover: {
              size: undefined,
              sizeOffset: 0
            }
          },
          tooltip: {
            enabled: true,
            shared: false,
            followCursor: true,
            intersect: true,
            marker: {
              show: false,
            },
            x: {
              formatter: function(value) {
                return i18n.t('month_colon') + value
              }
            },
            y: {
              formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
                let seizureObservation = w.config.series[seriesIndex].seizureObservation
                let label = value === 100 && seizureObservation === 0 ? i18n.t('over_100') : value
                return label
              }
            }
          },
          title: {
            text: '',
            align: 'left',
          },
          grid: {
            xaxis: {
              lines: {
                  show: true
              }
            },   
            yaxis: {
              lines: {
                  show: true
              }
            },
            padding: {
                top: 0,
                right: 10,
                bottom: 0,
                left: 160
            },
          },
          xaxis: {
            type: "category",
            categories: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          },
          yaxis: {
            labels: {
              formatter: (value) => {
                let label = value === 0 ? '' : `${value}%`
                return label
              },
              style: {
                colors: ['#fd8ea1'],
                cssClass: 'apexcharts-cc-label',
              },
            },
            tickAmount: 8,
            max: 100,
            min: -100,
            axisTicks: {
              show: true,
              borderType: 'solid',
              color: '#E0E0E0',
              width: 80,
              offsetX: 160,
              offsetY: 0
            },
          },
          legend: {
            show: false
          },
          annotations: {
            yaxis: [
              {
                x: 0,
                strokeDashArray: 0,
                borderColor: '#111',
                borderWidth: 0.5,
                opacity: 1,
                offsetX: -250,
                width: '200%',
              },
              {
                y: 12,
                borderWidth: 0,
                label: {
                  text: this.$t('deterioration'),
                  textAnchor: 'start',
                  position: 'left',
                  offsetX: -180,
                  offsetY: -45,
                  rotate: 0,
                  style: {
                    background: '#fff',
                    stroke: '#fff',
                    cssClass: 'yaxis-annotation-label-point',
                  }
                },
              },
              {
                y: -12,
                borderWidth: 0,
                label: {
                  text: this.$t('invalid'),
                  textAnchor: 'start',
                  position: 'left',
                  offsetX: -180,
                  offsetY: 25,
                  rotate: 0,
                  style: {
                    background: '#fff',
                    stroke: '#fff',
                    cssClass: 'yaxis-annotation-label-point',
                  }
                },
              },
              {
                y: -37,
                borderWidth: 0,
                label: {
                  text: this.$t('decrease'),
                  textAnchor: 'start',
                  position: 'left',
                  offsetX: -180,
                  offsetY: 25,
                  rotate: 0,
                  style: {
                    background: '#fff',
                    stroke: '#fff',
                    cssClass: 'yaxis-annotation-label-point',
                  }
                },
              },
              {
                y: -62,
                borderWidth: 0,
                label: {
                  text: this.$t('valid'),
                  textAnchor: 'start',
                  position: 'left',
                  offsetX: -180,
                  offsetY: 25,
                  rotate: 0,
                  style: {
                    background: '#fff',
                    stroke: '#fff',
                    cssClass: 'yaxis-annotation-label-point',
                  }
                },
              },
              {
                y: -87,
                borderWidth: 0,
                label: {
                  text: this.$t('significant_effect'),
                  textAnchor: 'start',
                  position: 'left',
                  offsetX: -180,
                  offsetY: 25,
                  rotate: 0,
                  style: {
                    background: '#fff',
                    stroke: '#fff',
                    cssClass: 'yaxis-annotation-label-point',
                  }
                },
              }
            ],
          }
        },
        chartOptions: {
          chart: {
            type: 'rangeBar',
            toolbar: {
              show: false
            },
            zoom: {
              enabled: false,
            }
          },
          plotOptions: {
            bar: {
              horizontal:true,
              vertical: true,
              distributed: false,
              barHeight: '70px',
              dataLabels: {
                hideOverflowingLabels: false,
                position: 'bottom'
              }
            }
          },
          dataLabels: {
            enabled: true,
            offsetY: -18,
            textAnchor: 'start',
            style: {
              colors: ['#000', '#000'],
              fontWeight: 400,
            }
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              formatter: function() {
                return '.'
              },
              style: {
                colors: ['#A5A5A5', '#A5A5A5'],
              },
              offsetY: -15,
            },
            tickAmount: 12,
            min: 0,
            max: 359,
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
            }
          },
          yaxis: {
            show: false
          },
          grid: {
            xaxis: {
              lines: {
                  show: true
              }
            },   
            yaxis: {
              lines: {
                  show: false
              }
            },
          },
          tooltip: {
            enabled: true,
            x: {
              show: false,
            },
            y: {
              formatter: function() {
                return ''
              }
            },
            marker: false,
            z: {
              show: false
            },
          },
          legend: {
            show: false,
          },
          states: {
            normal: {
              filter: {
                type: 'none',
                value: 0,
              }
            },
            hover: {
              filter: {
                type: 'none',
                value: 0,
              }
            },
            active: {
              allowMultipleDataPointsSelection: false,
              filter: {
                type: 'none',
                value: 0,
              }
            },
          },
        },
      }
    },
    computed: {
      ...mapState({
        errorMsg: state => state.patient.errorMsg,
        otpAccessToken: state => state.otp.otpAccessToken,
        listMedicines: state => state.medicine.medicines,
        seizureChangeRate: state => state.patient.seizureChangeRate,
        medicineColors: state => state.medicineColor.medicineColors,
        medicineShortcuts: state => state.medicineShortcut.medicineShortcuts,
      }),
      medicineOptions() {
        return _.uniqBy(_.flatMap(this.listMedicines, 'medicine_record'), 'medicine_name')
      },
      medicineTimeOptions() {
        let medicines = this.getMedicines(this.listMedicines)
        let medicineTimes = medicines.filter(medicine => medicine.name === this.valueMedicineSelected)
        let result = _.uniqWith(medicineTimes, _.isEqual);
        result = this.handleMedicineTimeOptions(result)
        return result
      },
      lineChart() {
        let seizureData = this.getChartLineData()
        return seizureData
      },
      medicineBefores() {
        let medicines = this.getMedicines(this.listMedicines)
        const medicinesObservation = medicines.filter(medicine => {
          const medicineEndDate = new Date(medicine.medicineEndDate)
          const lastThirtyDay =  new Date(this.seizureChangeRate.list_medicine_before[0].from_last_thirty_date)
          const endObservationDay =  new Date(this.seizureChangeRate.list_medicine_before[0].to_date)
          return medicineEndDate.getTime() >= lastThirtyDay.getTime() && medicineEndDate.getTime() <= endObservationDay.getTime()
        })
        const medicineRecord = medicinesObservation.map((medicine) => medicine.name)
        return medicineRecord
      },
      medicines() {
        let medicinesTaken = this.getMedicines(this.seizureChangeRate.medicine_taken)
        let medicines = _.uniq(_.map(medicinesTaken, 'name'))
        this.numberItemMedicine = medicines.length === 1 ? 2 : medicines.length === 2 ? 3 : medicines.length
        return medicines
      },
      orderByShortcat() {
        let orderByShortcat = _.orderBy(this.seizureChangeRate.seizure_data, 'shortcat_index')
        orderByShortcat.push(orderByShortcat.shift())
        return orderByShortcat;
      },
      medicineColorShortcuts() {
        let medicineColors = _.keyBy(this.medicineColors, 'medicine_name')
        let medicineShortcuts = this.medicineShortcuts
        medicineShortcuts.forEach(medicine => {
            let medicineName = medicine.medicine_name
            if(medicineColors[medicineName]) {
                medicine.dr_site_color = medicineColors[medicineName].dr_site_color_bold
            }
        });
        return medicineShortcuts
      }
    },
    created() {
      window.addEventListener("resize", this.changeStyleTimeLine);
    },
    async mounted () {
    },
    methods: {
      async getSeizureChangeRateData() {
        this.isLoading = true
        this.isShowGraph = false
        this.statusUpdateLine = true
        let childId = _.head(this.listMedicines).child_id
        let times = this.valueTimeSelected.split('~')
        if(childId){
          let params = {
            childId: childId,
            from_date: times[0].trim(),
            to_date: times[1].trim(),
            medicine_name: this.valueMedicineSelected,
            typeOfUser: this.$store.state.auth.typeOfUser
          }
          //add property pharmacy_user_id if use is pharmacy
          if (this.$store.state.auth.typeOfUser === 'pharmacy') {
            params.pharmacy_user_id = this.$store.state.auth.doctorInfo.id
          }
          await this.$store.dispatch("patient/getDataSeizureChangeRate", { params: params })
          
          this.isLoading = false
          this.medicines
          const countLastMonths = this.seizureChangeRate.seizure_data.map((item) => item.count_last_month)
          return _.sum(countLastMonths) === 0 ? this.$bvModal.show('seizure-observation') : this.isShowGraph = true
        }
      },
      customLabelCheckBox() {
        jQuery(document).ready(function($) {
          $(".type-seizures .el-checkbox__label").each(function(index){
            const $label = $(this).closest("label.el-checkbox")
            const shortcatIndex = $label.attr("data-shortcat-index")
            $(this).after(`<div class="sz-border-area"><ol class="border-bar-${shortcatIndex}"><li><span></span></li><li><span></span></li></ol></div>`);
          })
        })
      }, 
      checkLegends() {
        let chartLine = this.$refs.chartLine
        this.seizureShortCat.forEach(typeSeizure => {
          this.checkedTypeSeizure.includes(typeSeizure.name) ?  chartLine.showSeries(typeSeizure.name) : chartLine.hideSeries(typeSeizure.name)
        });
      },
      updateDataLabelLineChartOption(val) {
        this.$refs.chartLine.updateOptions({
          dataLabels: {
            enabled: val
          }
        })
      },
      getMedicines(patientMedicines) {
        let results = []
        const today = moment().format('YYYY-MM-DD')
        let medicineTakenByName = []
        patientMedicines.forEach(medicineTaken => {
          let medicineStartDate = medicineTaken.medicine_start_date
          let medicineEndDay = medicineTaken.medicine_end_date
          let prescriptionId = medicineTaken.prescription_id
          medicineTaken.medicine_record.forEach((record) => {
            medicineTakenByName.push({ name: record.medicine_name, medicineStartDate: medicineStartDate, medicineEndDate: medicineEndDay, prescriptionId: prescriptionId })
          })
        });
        let medicineTakenSortByDate =  _.sortBy(medicineTakenByName, medicine => medicine.medicineStartDate)

        medicineTakenSortByDate.forEach(medicine => {
          let mecicineDate = medicineTakenSortByDate.filter(m => {
            return  moment(m.medicineStartDate) > moment(medicine.medicineStartDate)
          })
          let medicineEndDate = _.head(_.sortBy(mecicineDate, medicine => medicine.medicineStartDate))
          let endDate
          if (medicineEndDate) {
            if (medicine.prescriptionId) {
              if (medicine.medicineEndDate) {
                endDate = moment(medicine.medicineEndDate)
              } else {
                endDate = moment()
              }
            } else {
              endDate = moment(medicineEndDate.medicineStartDate)
            }
          } else {
            if (medicine.prescriptionId && medicine.medicineEndDate) {
              endDate = moment(medicine.medicineEndDate)
            } else {
              endDate = moment()
            }
          }
          if (!medicineEndDate) {
            if (medicine.prescriptionId && medicine.medicineEndDate) {
              medicine.nextOther = true
            } else {
              medicine.nextOther = false
            }
          } else {
            if (medicine?.name === medicineEndDate?.name) {
              medicine.nextOther = false
            } else {
              if (medicine.prescriptionId && !medicine.medicineEndDate) {
                medicine.nextOther = false
              } else {
                medicine.nextOther = true
              }
            }
          }
          medicine.medicineEndDate = endDate.format('YYYY-MM-DD')
        })

        medicineTakenSortByDate.forEach(medicine => {
          let medicineRecord = this.getMedicineWithEndDate(medicineTakenSortByDate, medicine)
          let endDate = moment(medicineRecord.medicineEndDate).format('YYYY-MM-DD') === today && !medicineRecord.nextOther ? moment() : medicineRecord.prescriptionId ? moment(medicineRecord.medicineEndDate) : moment(medicineRecord.medicineEndDate).subtract(1, "days")
          medicineRecord.medicineEndDate = endDate.format('YYYY-MM-DD')
          results.push(medicineRecord)
        })
        return this.sortMedicines(_.uniq(results))
      },
      handleMedicineTimeOptions(medicineTimes) {
        let tamp = []
        let dup = []
        medicineTimes.forEach(medicine => {
          let duplicate = tamp.filter(item => item.medicineStartDate === medicine.medicineStartDate)
          tamp.push(medicine)
          if(duplicate.length) {
            dup = [{...medicine}, [...duplicate]]
          }
        })
        if(dup.length) {
          dup = dup.flat()
          const maxTime = dup.reduce((value, item) => {
            let valueMedicineEndDate = new Date(value.medicineEndDate);
            let itemMedicineEndDate = new Date( item.medicineEndDate);
            return valueMedicineEndDate.getTime() > itemMedicineEndDate.getTime() ? value : item
          }, {});
          let result = medicineTimes.filter(item => item.medicineStartDate !== maxTime.medicineStartDate)
          result = [...result, {...maxTime}]
          return result
        }
        return medicineTimes
      },
      getChartLineData() {
        let seizureData = this.seizureChangeRate?.seizure_data ?? []
        let seizureLine = []
        if(seizureData.length){
          if(!seizureData.find(seizure => seizure.name === this.$t('total'))){
            let allData = this.allSeizuresData(seizureData)
            seizureData.unshift(allData)
          }
          seizureData.forEach(seizure => {
            let seizureObservation = seizure.count_last_month
            let name = ''
            let shortcatIndex = ''
            let seizureTypeData = []
            name = seizure.shortcat_name
            shortcatIndex = seizure.shortcat_index
            if(seizure.shortcat_name === 'Other'){
              shortcatIndex = 'other'
              name = this.$t('other_seizures')
            }
            else if (!name) {
              name = this.shortcatLabel[shortcatIndex]
            }
            seizure.data.forEach(data => {
              let result
              if(seizureObservation !== 0) {
                result = (((data - seizureObservation) / seizureObservation) * 100).toFixed(2)
              }
              result = result > 100 || seizureObservation === 0 ? 100 : result
              if(data === null) result = null

              seizureTypeData.push(result)
            })
            seizureTypeData.unshift(0)
            seizureLine.push({
              name: name,
              shortcatIndex: shortcatIndex,
              data: seizureTypeData,
              seizureObservation: seizureObservation
            })
          });
          let seizureOther = seizureLine.find(seizure => seizure.name === this.$t('seizures_type_and_others'))
          seizureLine = seizureLine.filter(seizure => seizure.name !== this.$t('seizures_type_and_others'))
          seizureOther && seizureLine.push(seizureOther);
        }
        this.seizureShortCat = seizureLine.map(line => { return {'name': line.name, 'shortcatIndex': line.shortcatIndex}})
        this.seizureData = seizureLine
        return seizureLine
      },
      timeLineMedicineChangeRate() {
        if(this.seizureChangeRate?.medicine_taken){
          let medicinesTaken = this.getMedicines(this.seizureChangeRate.medicine_taken)
          const endMedicineDate = this.seizureChangeRate.list_medicine_before[0].end_medicine_date
          const times = this.valueTimeSelected.split('~')
          const medicineSelectedEndDate =  times[1].trim()
          const endDate = new Date(medicineSelectedEndDate).getTime() > new Date(endMedicineDate).getTime() ? medicineSelectedEndDate : endMedicineDate
          let dates = this.getListDateUseMedicine()
          let seriesTimeLine = []
          let listShowed = []
          while(medicinesTaken.length > listShowed.length) {
            let data = []
            let listEndDate = {}
            medicinesTaken.forEach((medicine, index) => {
              if(!listShowed.includes(index)) {
                let startMedicine = dates.indexOf(medicine.medicineStartDate)
                let endMedicine = dates.indexOf(medicine.medicineEndDate)
                if(medicine.medicineEndDate === moment().format('YYYY-MM-DD')){
                    endMedicine = dates.indexOf(endDate)
                }
                if(!listEndDate[medicine.name] || startMedicine > listEndDate[medicine.name]) {
                  listEndDate[medicine.name] = endMedicine
                  let dataItem = {
                    x : medicine.name,
                    y: [
                      startMedicine,
                      endMedicine
                    ],
                    fillColor: this.getMedicineColor(medicine.name)
                  }
                  data.push(dataItem)
                  listShowed.push(index)
                }
              }
            });
            seriesTimeLine.push({data})
            seriesTimeLine.push({data: [{x: '', y: [0,0]}]})
          }
          this.timeLineMedicine = this.dotsTimeLine(seriesTimeLine)
        }
      },
      dotsTimeLine(seriesTimeLine) {
        seriesTimeLine.forEach(timeLines => {
          let dotsTimeLine = []
          let duplicateTimeLine = []
          timeLines?.data?.forEach((item, index, object) => {
            const [y1, y2] = item.y
            if(y2 < 359){
              let duplicate = timeLines?.data?.filter(data => data.x === item.x && data.y[0] === item.y[0])
              if(duplicate.length) duplicateTimeLine.push(duplicate)
              for(let i = y1; i <= y2; i+=10){
                let dataItem = JSON.parse(JSON.stringify(item))
                dataItem.y[0] =  dataItem.y[0] > y1 ?  i + 20 : i
                dataItem.y[1] = dataItem.y[0] + 5
                dotsTimeLine.push(dataItem)
              }
              dotsTimeLine[dotsTimeLine.length - 1].y[1] = y2
            }
          })
          let timeLineFull =  timeLines?.data?.filter(item => item.y[1] >= 359)
          duplicateTimeLine.flat().forEach(element => {
            if(element.y[1] < 359) return  element.fillColor = '#ffffff00'
          });
          let result =  _.flatMap([...dotsTimeLine, ...timeLineFull, ...duplicateTimeLine])
          result = _.sortBy(result, [function(o) { return o.y[0], o.y[1]; }]);
          let medicinesMove = result.filter(medicine => medicine.x === this.valueMedicineSelected)
          let medicinesData = result.filter(medicine => medicine.x !== this.valueMedicineSelected)
          medicinesData.unshift(medicinesMove);
          timeLines.data = medicinesData.flat()
        })
        return seriesTimeLine
      },
      getMedicineWithEndDate(medicineTakenSortByDate, medicine) {
        let record = medicineTakenSortByDate.find(element => element.name === medicine.name && element.medicineStartDate === medicine.medicineEndDate)
        if(record && medicine.medicineStartDate !== medicine.medicineEndDate){
          record.medicineStartDate = medicine.medicineStartDate
          return this.getMedicineWithEndDate(medicineTakenSortByDate,  record)
        }
        return medicine
      },
      getMedicineColor(medicineName) {
        const medicineColor = this.medicineColors.find((item) => item.medicine_name === medicineName)
        if (medicineColor) {
          return medicineColor.dr_site_color_bold
        }
        return '#FF89C0'
      },
      getListDateBetweenToDate(from, to) {
        const dates = []
        for (var m = moment(from); m.diff(to, 'days') <= 0; m.add(1, 'days')) {
          const date = m.format('YYYY-MM-DD')
          dates.push(date)
        }
        return dates
      },
      getListDateUseMedicine() {
          const startDate = this.seizureChangeRate.list_medicine_before[0].start_medicine_date
          const endMedicineDate = this.seizureChangeRate.list_medicine_before[0].end_medicine_date
          const times = this.valueTimeSelected.split('~')
          const medicineSelectedEndDate =  times[1].trim()
          const endDate = new Date(medicineSelectedEndDate).getTime() > new Date(endMedicineDate).getTime() ? medicineSelectedEndDate : endMedicineDate
          return this.getListDateBetweenToDate(startDate, endDate)
      },
      sortMedicines(medicines) {
        let medicinesMove = medicines.filter(medicine => medicine.name === this.valueMedicineSelected)
        let medicinesData = medicines.filter(medicine => medicine.name !== this.valueMedicineSelected)
        medicinesData.unshift(medicinesMove);
        return medicinesData.flat()
      },
      allSeizuresData(seizureData) {
        let allData = []
        let totalSeizuresObservation = 0
        seizureData.forEach(seizure => {
          totalSeizuresObservation += seizure.count_last_month
          for (const [key, value] of Object.entries(seizure.data)) {
            allData[key] = allData[key] ?? 0 
            allData[key] = value !== null ? allData[key] + value : null
          }
        });
        const data = {
            shortcat_name: this.$t('total'),
            data: allData,
            count_last_month: totalSeizuresObservation,
            shortcat_index: 'total'
          }
        return data
      },
      settingForTimeLineChart() {
        let dates = this.getListDateUseMedicine()
        let medicineShortcuts = this.medicineShortcuts
        let medicineName = this.medicineName
        let medicinesTaken = this.getMedicines(this.seizureChangeRate.medicine_taken)
        let labelsData = []
        this.chartOptions.dataLabels = {...this.chartOptions.dataLabels, ...{
          formatter:  function(value, { seriesIndex, dataPointIndex, w }) {
            let label = w.config.series[seriesIndex].data[dataPointIndex].x || ''
            let medicineShortcutName = ''
            if(!labelsData.includes(label)){
              const medicineShortcut = medicineShortcuts.find((item) => item.medicine_name === label)
              medicineShortcutName = medicineShortcut?.medicine_shortcut_name ? medicineShortcut.medicine_shortcut_name : label
              labelsData.push(label)
            } else {
              medicineShortcutName = ''
            }
            if(w.config.series[seriesIndex + 1] == undefined) {
              labelsData = []
            }
            return `${medicineShortcutName}`
          },
        }}
        this.chartOptions.tooltip.x = {...this.chartOptions.tooltip.x, ...{
          formatter: function(val, opts) {
            let from = moment(dates[val]).format('YYYY/MM/DD')
            let to = moment(dates[val]).format('YYYY/MM/DD')
            if(to >=  moment().format('YYYY/MM/DD')){
              if (val === -1) {
                const name = medicineName.replace(':', '')
                const medicine = medicinesTaken.find((item) => item.name === name)
                to = medicine ? medicine.medicineStartDate : ''
              } else {
                to = ''
              }
            }
            return `${to}`
          },
        }}
        this.chartOptions.tooltip.y = {...this.chartOptions.tooltip.y, ...{
          formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
            medicineName = value
            return `${value} <br/>`
            
          },
        }}
      },
      updateSeriesLine() {
        if(this.statusUpdateLine){
          this.statusUpdateLine = false
          this.checkedTypeSeizure = this.seizureShortCat.length >= 2 ? [this.seizureShortCat[0].name] : []
        }
      },
      mountedLineChart() {
        this.checkedTypeSeizure = this.seizureShortCat.length >= 2 ? [this.seizureShortCat[0].name] : []
      },
      getLastViewed(lastViewed) {
        if (lastViewed) {
          const date = lastViewed.split(' ')[0]
          const [year, month, day] = date.split('-')
          return this.$t('year_month_day', {year: year, month: month, day: day})
        }
        return lastViewed
      },
      changeStyleTimeLine () {
        setTimeout(() => {
          const yLineChart = $('.apexcharts-yaxis line')
          const rectYChart = $('.apexcharts-yaxis-annotations rect')
          const tableTh = $('.seizure-change-rate-table th.st-obs')
          const typeSeizureName = $('.seizure-change-rate-table .type-seizure-name')
          const withColumnSeizureTh =  $(tableTh).width()
          $(typeSeizureName).css("width", 193 - withColumnSeizureTh)
          $(yLineChart[4]).css("display", "none")
          $(rectYChart[0]).css("stroke", "#DCDCDC")
        }, 500);
      }
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.changeStyleTimeLine);
    },
    watch: {
      checkedTypeSeizure() {
        if (this.isShowGraph) {
          this.checkLegends()
          if(this.checkedTypeSeizure.length === 1) {
            this.updateDataLabelLineChartOption(true)
          }else{
            this.updateDataLabelLineChartOption(false)
          }
          let colors = ['#ff0000']
          // Set colors default for Seizure shortcut A, B, C
          for(let i = 0; i <= this.shortcatLabel.indexOf('C'); i++){
            colors.push(defaultDatasets.find(data => data.index === i).borderColor)
          }
          let dashArray = [0]
          this.orderByShortcat.forEach(seizure => {
            if(seizure.shortcat_index !== "total" && seizure.count_last_month === 0) dashArray.push(3) 
            else if(seizure.shortcat_index !== "total" && seizure.count_last_month !== 0) dashArray.push(0)
            const colorIndex = defaultDatasets.find(data => data.index === seizure.shortcat_index)
            if(colorIndex){
              if (!colors.includes(colorIndex.borderColor))
                colors.push(colorIndex.borderColor)
            }
          })
          colors.push(seizureColor.seizureOther)
          this.$refs.chartLine.updateOptions({
            colors: colors,
            stroke: {
              dashArray: dashArray
            }
          })
          this.changeStyleTimeLine()
        }
      },
      seizureChangeRate() {
        this.settingForTimeLineChart()
        this.timeLineMedicineChangeRate()
        this.customLabelCheckBox()
      },
      valueMedicineSelected() {
        if(this.valueMedicineSelected) {
          this.valueTimeSelected = ''
        }
      }
    }
  }
</script>
